import { render, staticRenderFns } from "./inactiveList.vue?vue&type=template&id=f29bdd38&scoped=true"
import script from "./inactiveList.vue?vue&type=script&lang=js"
export * from "./inactiveList.vue?vue&type=script&lang=js"
import style0 from "./inactiveList.vue?vue&type=style&index=0&id=f29bdd38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29bdd38",
  null
  
)

export default component.exports